import { Component, Input } from "@angular/core";
import { ApiMembershipProduct, ApiMembershipProductFeature, MembershipProductFeaturesApi } from "@tytapp/api";

let CACHED_FEATURES : ApiMembershipProductFeature[] = null;

@Component({
    selector: 'tyt-membership-features',
    templateUrl: './membership-features.component.html',
    styleUrls: ['./membership-features.component.scss']
})
export class MembershipFeaturesComponent {
    constructor(
        private api : MembershipProductFeaturesApi
    ) {
    }

    async ngOnInit() {
        this.features = CACHED_FEATURES;
        this.features = CACHED_FEATURES = await this.api.all().toPromise()
    }

    features : ApiMembershipProductFeature[];

    @Input()
    product : ApiMembershipProduct;

    hasFeature(feature : ApiMembershipProductFeature) {
        if (!this.product || !this.product.feature_skus)
            return false;
        return this.product.feature_skus.includes(feature.sku);
    }
}